module.exports = __webpack_public_path__ + "img/item-bonuses.8ea96a01.svg";